import styled from 'styled-components';
import Geosuggest from 'react-geosuggest';
import {
  multiply,
  spacer,
  get,
  gray,
  borderRadius,
  boxShadow,
  fontWeight,
  color,
  zIndex,
  fontStyle,
} from '@whitelabel/helpers/style';

// eslint-disable-next-line import/prefer-default-export
export const StyledAddressInput = styled(Geosuggest)`
  ${fontStyle('paragraph')};
  position: relative;
  text-align: start;

  .geosuggest__input {
    width: 100%;
    height: ${multiply(spacer, 4)};
    padding: ${spacer};
    border: ${get('borderWidth')} solid ${gray(500)};
    border-radius: ${borderRadius('base')};

    &:focus {
      border-color: ${gray(700)};
      outline: 0;
    }
    &:disabled {
      background-color: ${gray(300)};
    }
  }

  .geosuggest__suggests {
    position: absolute;
    top: ${multiply(spacer, 4.5)};
    right: 0;
    left: 0;
    z-index: ${zIndex('content')};
    max-height: ${multiply(spacer, 31.25)};
    padding: 0;
    list-style: none;
    background: ${color('white')};
    border: ${get('borderWidth')} solid ${gray(300)};
    box-shadow: ${boxShadow('base')};
    transition: max-height 0.2s, border 0.2s;
  }
  .geosuggest__suggests--hidden {
    max-height: 0;
    overflow: hidden;
    border-width: 0;
  }

  .geosuggest__item {
    min-height: ${multiply(spacer, 2.5)};
    padding: ${multiply(spacer, 0.5)} ${multiply(spacer, 1.4375)};
    cursor: pointer;

    :not(:last-child) {
      border-bottom: ${get('borderWidth')} solid ${gray(300)};
    }
  }

  .geosuggest__item:hover,
  .geosuggest__item:focus {
    background-color: ${gray(200)};
  }

  .geosuggest__item--active {
    background-color: ${gray(200)};
  }

  .geosuggest__item__matched-text {
    font-weight: ${fontWeight('bold')};
  }
`;
